import React from 'react';
import { Clock, AlertTriangle, FileText, AlertCircle } from 'lucide-react';
import MetricsGrid from '@components/common/MetricsGrid';
import MetricCard from '@components/common/MetricCard';
import type { ProgramLeadMetricsData } from '@app-types';

interface ProgramLeadMetricsProps {
  data: ProgramLeadMetricsData | undefined;
  isLoading: boolean;
}

const ProgramLeadMetrics: React.FC<ProgramLeadMetricsProps> = ({ data, isLoading }) => {
  const metrics = [
    {
      label: 'Scheduling Late',
      value: data?.scheduling_late ?? 0,
      subtitle: 'Contracts in late scheduling window',
      icon: Clock,
      variant: 'orange' as const,
    },
    {
      label: 'Scheduling Critical',
      value: data?.scheduling_critical ?? 0,
      subtitle: 'Contracts in critical scheduling window',
      icon: AlertTriangle,
      variant: 'red' as const,
    },
    {
      label: 'Assessments Open',
      value: data?.assessments_open ?? 0,
      subtitle: 'Pending evidence or past due',
      icon: FileText,
      variant: 'blue' as const,
    },
    {
      label: 'Assessments Past Due',
      value: data?.assessments_past_due ?? 0,
      subtitle: 'Evidence past due',
      icon: AlertCircle,
      variant: 'orange' as const,
    },
  ];

  return (
    <MetricsGrid>
      {metrics.map((metric) => {
        const IconComponent = metric.icon;
        return (
          <MetricCard
            key={`metric-${metric.label}`}
            icon={<IconComponent size={24} />}
            label={metric.label}
            value={metric.value}
            subtitle={metric.subtitle}
            variant={metric.variant}
            loading={isLoading}
          />
        );
      })}
    </MetricsGrid>
  );
};

export { ProgramLeadMetrics };
